import {Component, Inject, Input} from '@angular/core';
import {FieldUiDataObj} from '../../../../../../../generated/generated-core.model';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MxFieldConfig} from '../../services/mx-field-customizer.service';
import {MxField} from '../../services/mxField';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from "../../../../../../shared/services/mx-translate.service";


@Component({
    selector: 'mx-field-set',
    standalone: false,
    templateUrl: './mx-field-set.component.html'
})
export class MxFieldSetComponent extends MxField {
    @Input() public collapsible: boolean = false;
    @Input() public collapsed: boolean = false;
    @Input() public sublist: Array<FieldUiDataObj>;
    @Input() fieldConfigs: Map<string, MxFieldConfig>;

    constructor(protected errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

}
